import React from "react";
import { Megaphone } from "lucide-react";
import { CAMPAIGN_STATUS_STYLE, CAMPAIGN_STATUS_LABEL, IN_PROGRESS_STATUSES } from "../features/campaign.constants";
import TrendSparkline from "../dashboard/TrendSparkline";

const pct = (num, den) => (den > 0 ? `${Math.round((num / den) * 1000) / 10}%` : "—");

export const getCampaignColumns = () => [
  {
    key: "campaign_name",
    label: "Campaign",
    width: "260px",
    fixed: true,
    sortable: true,
    render: (row) => (
      <div className="space-y-0.5">
        <div className="flex items-center gap-1.5">
          <Megaphone size={12} className="text-text_muted flex-shrink-0" />
          <span className="text-xs font-semibold text-text_primary truncate max-w-[200px]" title={row.campaign_name}>
            {row.campaign_name || "—"}
          </span>
        </div>
        <p className="text-[11px] text-text_muted pl-[18px] truncate max-w-[210px]" title={row.subject}>
          {row.subject}
        </p>
      </div>
    ),
  },
  {
    key: "status",
    label: "Status",
    width: "110px",
    render: (row) => {
      const s = CAMPAIGN_STATUS_STYLE[row.status] || CAMPAIGN_STATUS_STYLE.DRAFT;
      return (
        <span className={`inline-flex items-center px-2 py-1 rounded-lg text-[11px] font-medium border ${s.bg} ${s.text} ${s.border}`}>
          {CAMPAIGN_STATUS_LABEL[row.status] || row.status}
        </span>
      );
    },
  },
  {
    key: "total_recipients",
    label: "Recipients",
    width: "100px",
    render: (row) => <span className="tabular-nums">{row.total_recipients}</span>,
  },
  {
    key: "progress",
    label: "Progress",
    width: "150px",
    render: (row) => {
      const inProgress = IN_PROGRESS_STATUSES.includes(row.status);
      const pctDone = row.total_recipients > 0 ? Math.min(100, Math.round((row.total_sent / row.total_recipients) * 100)) : 0;
      return (
        <div className="space-y-1 min-w-[110px]">
          <span className="text-[11px] tabular-nums text-text_secondary">
            {row.total_sent}/{row.total_recipients}
          </span>
          {inProgress && (
            <div className="h-1.5 w-full rounded-full bg-surface_alt overflow-hidden">
              <div className="h-full rounded-full bg-primary" style={{ width: `${pctDone}%` }} />
            </div>
          )}
        </div>
      );
    },
  },
  {
    key: "open_rate",
    label: "Open Rate",
    width: "100px",
    render: (row) => <span className="tabular-nums">{pct(row.total_opened, row.total_sent)}</span>,
  },
  {
    key: "trend",
    label: "Trend",
    width: "80px",
    sortable: false,
    render: (row) => <TrendSparkline sent={row.total_sent} opened={row.total_opened} />,
  },
];
